<template>
  <base-stack class="remarks">
    <base-stack direction="row">
      <base-button @click="shouldAddRemark = true">Add remark</base-button>
    </base-stack>
    <app-user-remark-cell v-if="shouldAddRemark" key="add" :target-user-id="user.id" @close="shouldAddRemark = false" />
    <base-stack as="ul">
      <app-user-remark-cell
        v-for="remark in user.remarks"
        :key="remark.id"
        :remark="remark"
        :target-user-id="user.id"
      />
    </base-stack>

    <p class="remarks__empty" v-if="user.remarks.length === 0">No remarks</p>
  </base-stack>
</template>

<script lang="ts">
import AppUserRemarkCell from '@/components/UserRemarkCell.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { User } from '../types/api';

@Component({
  components: { AppUserRemarkCell },
})
export default class UserRemarks extends Vue {
  @Prop({ required: true, default: false }) user!: User;

  public shouldAddRemark: boolean = false;
}
</script>

<style lang="scss" scoped>
.user-remarks {
  padding: 1rem 0;
}

.box {
  margin: 16px 0;
  padding: 16px;
  border: 1px solid $color-theme-red;

  h3 {
    font-weight: bold;
  }
}

.remarks {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  ul {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  &__empty {
    font-style: italic;
  }
}
</style>
